import { useParams } from "react-router";
import FormType from "enums/FormType";
import { useEffect } from "react";

import {
    loadForm,
    loadFormNames,
    selectLoadError,
} from "features/qualityForm/qualityFormSlice";
import { copyFormSliceActions } from "features/qualityForm/formEditor/copyFormSlice";
import FormEditorContainer from "features/qualityForm/formEditor/FormEditorContainer";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { selectFeatureToggle } from "features/featureToggles/featureToggleSlice";
import FeatureToggle from "enums/FeatureToggle";
import { useLocale } from "features/i18n/useLocale";
import embeddingService from "services/embeddingService";
import {
    getFormsListRoutePath,
    getOldFormsListRoutePath,
} from "util/routeUtils";

export function SurveyForm() {
    const { surveyFormId } = useParams();
    const locale = useLocale();

    const loadError = useAppSelector(selectLoadError);
    const isAdminUIDecompEnabled = useAppSelector((state) =>
        selectFeatureToggle(state, FeatureToggle.ADMIN_UI_DECOMPOSITION)
    );

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (loadError?.formType) {
            const path = isAdminUIDecompEnabled
                ? getFormsListRoutePath(loadError.formType)
                : getOldFormsListRoutePath(loadError.formType);
            embeddingService.requestNavigation(path);
        }
    }, [loadError, isAdminUIDecompEnabled]);

    useEffect(() => {
        if (surveyFormId) {
            dispatch(
                loadForm({
                    formType: FormType.SURVEY,
                    formId: surveyFormId,
                    language: locale,
                })
            );
            dispatch(loadFormNames(FormType.SURVEY));
            dispatch(copyFormSliceActions.initializeCopyingViewMode());
        }
    }, [dispatch, surveyFormId]);

    // If there's a load error, don't render anything (redirect will happen from Redux)
    if (loadError) {
        return null;
    }

    return <FormEditorContainer formType={FormType.SURVEY} />;
}
